/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/ban-types */

import { TranslateCompiler } from '@ngx-translate/core';

/**
 * Adapted from:
 * https://stackoverflow.com/questions/60772119/how-to-translate-a-key-inside-another-translation-in-ngx-translate/60772120#60772120
 */
export class CustomTranslationCompiler implements TranslateCompiler {
    /**
     * This function is needed to implement the interface, but doesn't
     * actually seem to be used anywhere
     *
     * @param value The translation value
     * @param lang The current language
     */
    public compile(value: string): string | Function {
        return value;
    }

    /**
     * Look at every translation and pre-translate any nested translation keys within them
     *
     * @param translations All of the translations for the app to be compiled
     * @param lang The current language
     */
    public compileTranslations(translations: any): any {
        for (const key in translations) {
            if (translations.hasOwnProperty(key)) {
                translations[key] = this.translateNestedTranslation(translations[key], translations);
            }
        }

        return translations;
    }

    /**
     * Use a regex to search for and replace translations inside translations
     * with their translated value
     *
     * @param value The translation value
     * @param translations All of the translations for the app
     */
    private translateNestedTranslation(value: string, translations: any): string {
        const searchRegex = /\[\[\s?([a-zA-Z-_:]*)\s?\]\]/g;
        let matches;

        while ((matches = searchRegex.exec(value)) != null) {
            if (matches.length > 0) {
                const searchKey = matches[1];
                const replaceRegex = new RegExp('\\[\\[\\s?' + searchKey + '\\s?\\]\\]', 'g');

                if (translations.hasOwnProperty(searchKey)) {
                    // Replace the full translate syntax with the translated value
                    value = value.replace(replaceRegex, translations[searchKey]);
                } else {
                    // If we can't find the value, display only the missing key instead of the full translate syntax
                    value = value.replace(replaceRegex, searchKey);
                    console.error(`Error: Unable to find translation '${searchKey}'!`, replaceRegex, value);
                }

                // JavaScript RegExp objects are stateful.
                // Since we modified the string we are matching against, we need to reset the index search stopped at
                // back to zero - otherwise if our replace was shorter than our key, we might miss the next key by
                // searching further in the string than we had before
                searchRegex.lastIndex = 0;
            }
        }
        return value;
    }
}
